var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "282.67 161 14.33 13.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-edit-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.833 174.182h6.667",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "transparent",
    "data-name": "Trac\\xE9 214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.389 164.182-9.26 9.26-2.962.74.74-2.963 9.26-9.259a1.571 1.571 0 0 1 2.14-.075 1.594 1.594 0 0 1 .082.075c.587.588.612 1.524.075 2.141a1.594 1.594 0 0 1-.075.081Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "transparent",
    "data-name": "Trac\\xE9 215"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenEdit);
export default __webpack_public_path__ + "static/media/pen-edit.5d6b1d6a6bf5243961e62ba4e49d14e6.svg";
export { ForwardRef as ReactComponent };